/**
 * Takes a base link along with some query parameters and an anchor tag and
 * returns a formed link given the parameters given. Example:
 * getLinkWithParams('example.com', { queryParams: { key: 'value&' }, anchor: 'top' })
 * returns: 'example.com?key=value%26#top'
 * @param {string} href String base link
 * @param {object} config Can contain keys queryParams as an object and anchor as a string
 */
const getLinkWithParams = (href, config) => {
  const { queryParams = {}, anchor } = config;
  const mHref = `${href}?`;
  const mQueryParams = Object.keys(queryParams)
    .map(paramKey => `${encodeURIComponent(paramKey)}=${encodeURIComponent(queryParams[paramKey])}`)
    .join('&');
  const mAnchor = anchor ? `#${anchor}` : '';
  return mHref + mQueryParams + mAnchor;
};

export default getLinkWithParams;
